<template>
  <el-select v-model="value" @change="change"
             filterable
             clearable
             remote
             :loading="loading"
             :remote-method="getDspSlotName"
             :multiple="multiple"
     placeholder="请选择DSP广告位">
    <el-option v-for="item in slotNameOptions" :key="item.dspSlotId" :label="item.dspSlotName"
      :value="item.dspSlotId" />
  </el-select>
</template>

<script>
import { getDspSlotName, getDspSlotDimName } from '@/api/select'
import { hot } from '@/api/hot'

export default {
  props: {
    modelValue: [String, Number],
    dspId: {
      type: [String, Number],
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: false
    },
    slotIsEnable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'change'],
  data () {
    return {
      slotNameOptions: [],
      value: undefined,
      loading: false,
      hasVal: undefined
    }
  },
  watch: {
    dspId () {
      if (this.multiple) {
        this.value = []
        this.change([])
      } else {
        this.value = ''
        this.change('')
      }
      this.getDspSlotName()
    }
  },
  methods: {
    getDspSlotName (query) {
      this.loading = true
      getDspSlotName({ dspId: this.dspId, slotIsEnable: this.slotIsEnable, searchKey: query }).then(res => {
        if (res.code === 200) {
          this.slotNameOptions = res.data
          this.slotNameOptions.map((item) => {
            item.dspSlotName = item.dspSlotName + '-' + item.dspSlotCode
          })
        }
      })
      this.loading = false
    },
    change (item) {
      const data = {
        maker: 'slotDspOnThe',
        onTheOrderId: item
      }
      if (item && !this.multiple) {
        hot(data)
      }
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
    },
    fun (val) {
      if (val) {
        val = val.replace(/^\s+|\s+$/gm, '')
        // this.value = val
        getDspSlotDimName({ name: val }).then(res => {
          this.slotNameOptions = res.data
          this.slotNameOptions.map((item) => {
            item.dspSlotName = item.dspSlotName + '-' + item.dspSlotCode
          })
        })
      } else {
        this.getDspSlotName()
      }
    }
  }
}
</script>

<style scoped>

</style>
